export enum DashboardTabsEnum {
    Types = "types",
    Frameworks = "frameworks",
    DataInventory = "data-inventory",
    RequestHandling = "request-handling",
    DataClassifications = "data-classifications",
}